// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { TransitionGroup } from 'react-transition-group'
import LoadingBar from 'react-redux-loading-bar'
import { Switch, Route } from 'react-router-dom'
import Waypoint from 'react-waypoint'

// Internal Dependencies:
import PageData from 'containers/PageData'
import PageEvents from 'containers/PageEvents'
// import PageEventsCurtains from 'containers/PageEventsCurtains'
// import PageEventsAladino from 'containers/PageEventsAladino'
import PageEventsTransition from 'containers/PageEventsTransition'
// import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import HeaderPrimary from 'components/HeaderPrimary/HeaderPrimary'
import HeaderMobilePrimary from 'components/HeaderPrimary/HeaderMobilePrimary'
import Menu from 'components/menu/menu'
// import PageHeader from 'components/PageHeader/PageHeader'
import PageNavFrame from 'components/PageNavFrame/PageNavFrame'
import Footer from 'components/Footer/Footer'
import About from 'views/pages/About'
import PasswordProtected from 'components/PageSections/_PasswordProtected'
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'

const siteImage = siteData.site_featured_image_url
const siteImageSrcset = siteData.site_featured_image_srcset

class SiteLayout extends React.Component {
	constructor() {
		super()

		this.state = {
			showPageNavFrameAtScroll: false
		}
	}

	showPageNavFrame = () => {
		this.setState( {
			showPageNavFrameAtScroll: true
		} )
	}

	hidePageNavFrame = () => {
		this.setState( {
			showPageNavFrameAtScroll: false
		} )
	}

	updateFavicon = ( color ) => {
		const link = document.querySelector( '.dynamic-favicon' )

		link.href = `${siteData.images_url}logo/logo-${color}.svg`
	}

	render() {
		const { isMobile, isIos, page, selectedArchive, type, location, match } = this.props
		const { showPageNavFrameAtScroll } = this.state
		const isHome = '/' == location.pathname
		let className = isHome ? 'site-wrap is-home' : 'site-wrap'
		let template = ''
		let showFooter = true
		let showPageNavFrame = false
		let contentHasLoaded = !! page
		let pageColor = ''

		if ( isIos ) {
			className += ' is-ios'
		}

		if ( isHome ) {
			// showFooter = false
			document.documentElement.classList.add( 'is-home' )
		} else {
			document.documentElement.classList.remove( 'is-home' )
		}

		if ( page && page.template ) {
			template = page.template
			className += ` page-${page.template}`

			if ( 'websites' == template ) {
				pageColor = 'orange'
				className += ' content-type-website'
			} else if ( 'brandings' == template ) {
				pageColor = 'purple'
				className += ' content-type-branding'
			} else if ( 'graphic_designs' == template ) {
				pageColor = 'green'
				className += ' content-type-graphic_design'
			}
		}

		if ( page && page.slug ) {
			template = page.template
			className += ` page-${page.slug}`
		}

		if ( page && page.content_type ) {
			if ( match.params.slug ) {
				className += ` content-type-${page.content_type}`

				if (
					! page.is_password_protected &&
					( 'website' == page.content_type || 'branding' == page.content_type || 'graphic_design' == page.content_type )
				) {
					className += ' content-type-work'
					showPageNavFrame = true

					if ( 'website' == page.content_type ) {
						pageColor = 'orange'
					} else if ( 'branding' == page.content_type ) {
						pageColor = 'purple'
					} else if ( 'graphic_design' == page.content_type ) {
						pageColor = 'green'
					}
				}
			}
		}

		if ( page.is_password_protected ) {
			showFooter = false
			className += ' is-password-protected'
		}

		if ( showPageNavFrameAtScroll ) {
			className += ' with-page-nav-frame'
		}

		if ( 'websites' == type || 'brandings' == type || 'graphic_designs' == type ) {
			contentHasLoaded = !! selectedArchive
		}

		if ( ! contentHasLoaded ) {
			showFooter = false
		}

		if ( pageColor ) {
			this.updateFavicon( pageColor )
		}

		return (
			<div className={ className }>
				<PageData { ...this.props } />
				<PageEvents />
				{/*<PageEventsAladino />*/}
				{/*<PageEventsCurtains />*/}
				<PageEventsTransition { ...this.props } />

				<div className="site">
					{/*<div className="loading">
						<LoadingSpinner />
					</div>*/}

					<HeaderMobilePrimary />

					<div className="main-wrap">
						<LoadingBar className="header-loading-bar" updateTime={ 100 } maxProgress={ 90 } progressIncrease={ 10 } />

						<HeaderPrimary match={ match } />

						{ showPageNavFrame &&
							<PageNavFrame match={ match } />
						}

						{ showPageNavFrame &&
							<Waypoint onEnter={ this.hidePageNavFrame } onLeave={ this.showPageNavFrame } topOffset={ -500 } />
						}

						{ siteData.site_is_protected &&
							<section className="main">
								<PasswordProtected sitewide={ true } />
							</section>
						||
							<section className="main">
								{ this.props.children }

								{ 'about' == template &&
									<About />
								}
							</section>
						}
					</div>
				</div>

				{ showFooter &&
					<Footer match={ match } />
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isMobile: state.site.isMobile,
		isIos: state.site.isIos,
		page: state.page.selected,
		selectedArchive: state.page.selectedArchive
	}
}

export default connect( mapStateToProps )( SiteLayout )



// WEBPACK FOOTER //
// ./views/layouts/SiteLayout.jsx